
import axios from "axios"

const DataSource = {
    handleErrors (response) {
        if (!response.ok) {
            throw Error(response)
        }
        return response
    },

    async searchAddress(input, onSuccess, onFailure) {
      const url = process.env.MIX_API_URL_SQ
      const payload = {...input, excludeProviders: 'Telstra'}
        return await axios.get(`${url}/v2/address`, {params: payload}).then((response) => {
            onSuccess(response.data)
        }).catch((response) => {
            if (response && (response.response && response.response.status !== 422 && response.response.status !== 401) || !response.response) {
                this.handleErrors(response)
            }
            onFailure(response)
        })
    },

    async getServiceQualification(input, onSuccess, onFailure) {
        const url = process.env.MIX_API_URL_SQ
        return await axios.get(`${url}/v2/service-qualification`, {params: input}).then((response) => {
            onSuccess(response.data)
        }).catch((response) => {
            if (response && (response.response && response.response.status !== 422 && response.response.status !== 401) || !response.response) {
                this.handleErrors(response)
            }
            onFailure(response)
        })
    },
}

export default DataSource


// WEBPACK FOOTER //
// ./resources/assets/js/DataSource.js